import { init_coverage } from './coverage_plugin';
let categoryItem = $('.category-item');

categoryItem.on('click', function(e) {
    e.preventDefault();
    let cat_id = $(this).attr('data-catid');
    $('.catId').val(cat_id);
    $('#categoryform').submit();
});

$('.date-item').on('click', function(e){
    e.preventDefault();
    $('.date-item').removeClass('active');
    $(this).addClass('active');
    let selectedDateVal = $(this).attr('data-dt');
    $('.selected-date').val(selectedDateVal);
});

$('.time-slot').on('click', function(e){
    e.preventDefault();
    $('.time-slot').removeClass('active');
    $(this).addClass('active');
    let selectedTimeVal = $(this).attr('data-tme');
    $('.selected-time-slot').val(selectedTimeVal);
});

$('.form-check-inline').on('click', function() {
    let checkBoxObj = $(this).find('.form-check-input');
    let checkBoxLabelObj = $(this).find('.form-check-label');
    let catValue = checkBoxObj.attr('value');
    let catLabel = checkBoxLabelObj.text();
    catLabel = catLabel.toLowerCase();
    
    if( catLabel == 'other' || catLabel == 'annet' || catValue == '16_ukjent' ) {
        $('.reason-text-group').show();
    } else {
        $('.reason-text-group').hide();
    }
});

$("#callAsap").change(function() {
    if(this.checked) {
        $('.contact-date-time').hide();
        $('.date-item').removeClass('active');
        $('.selected-date').val('');
        $('.time-slot').removeClass('active');
        $('.selected-time-slot').val('');
    }
    else {
        $('.contact-date-time').show();
    }
});

$('#gotoStep1').on('click', function(e) {
    e.preventDefault();
    history.back();
});


$('#serviceNowForm input[type="text"], #serviceNowForm input[type="email"]').blur(function(){
    if($(this).attr('type') == 'email') {
        let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!$(this).val().match(mailformat)) {
            $(this).parent('div').addClass("error");
        } else {
            $(this).parent('div').removeClass("error");
        }
    } else {
        if(!$(this).val()){
            $(this).parent('div').addClass("error");
        } else {
            $(this).parent('div').removeClass("error");
        }
    }
    
});

$('#submitBtn').on('click', function(e) {
    e.preventDefault();
    let okFlag = true;
    let formObj = $('#serviceNowForm');
    let firstErrorElement = '';
    let counter = 0;
    $('#serviceNowForm *').filter('[required]').each(function() { 
        if($(this).attr('type') == 'email') {
            let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if(!$(this).val().match(mailformat)) {
                $(this).parent('div').addClass("error");
                okFlag = false;
            } else {
                $(this).parent('div').removeClass("error");
            }
        } else {
            if(!$(this).val()){
                $(this).parent('div').addClass("error");
                okFlag = false;
            } else {
                $(this).parent('div').removeClass("error");
            }
        }
        if(!okFlag && counter == 0) {
            firstErrorElement = $(this);
            counter++;
        }
    });

    if(okFlag) {
        formObj.submit();
    } else {
        $('html, body').animate({
            scrollTop: firstErrorElement.offset().top - 150
        }, 100);
        return false;
    }
});

$(document).ready(function() {
    $('.date-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 8,
        slidesToScroll: 8,
        arrows: true,
        nextArrow: '<div class="next-arrow"><span></span></div>',
        prevArrow: '<div class="prev-arrow"><span></span></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
                dots: false,
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 6,
            }
          },
          {
            breakpoint: 600,
            settings: {
                dots: false,
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 5
            }
          },
          {
            breakpoint: 480,
            settings: {
                dots: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    
    let $sectionObj = $('.global-coverage-search-widget');
    init_coverage($sectionObj);
});

function newFunction(okFlag) {
    alert(okFlag);
}
